import ReCAPTCHA from 'react-google-recaptcha';

export const Captcha = ({ key = '', onChange = () => {} }) => (
  <ReCAPTCHA key={key} sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA} onChange={onChange} size="normal" type="image" />
);

export default Captcha;
